import React from "react";
import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  isSameMonth,
  isSameDay,
  addDays,
  addMonths,
  subMonths,
} from "date-fns";
import { CustomIcon } from "../../../UI";
import "./style.scss";

const CalendarPopup = ({ selectedDate, onSelectDate }) => {
  const [currentMonth, setCurrentMonth] = React.useState(
    selectedDate ? new Date(selectedDate) : new Date()
  );

  // Update current month when selectedDate changes
  React.useEffect(() => {
    if (selectedDate) {
      setCurrentMonth(new Date(selectedDate));
    }
  }, [selectedDate]);

  const renderDays = () => {
    const startDate = startOfWeek(startOfMonth(currentMonth), {
      weekStartsOn: 1, // Monday
    });
    const endDate = endOfWeek(endOfMonth(currentMonth), { weekStartsOn: 1 });
    const days = [];

    let current = startDate;

    while (current <= endDate) {
      const thisDay = new Date(current);

      const isInMonth = isSameMonth(thisDay, currentMonth);
      const isSelected = selectedDate && isSameDay(thisDay, new Date(selectedDate));
      const isToday = isSameDay(thisDay, new Date());

      days.push(
        <div
          key={thisDay.toISOString()}
          className={`calendar-day ${!isInMonth ? "dimmed" : ""} ${
            isSelected ? "selected" : ""
          } ${isToday && !isSelected ? "today" : ""}`}
          onClick={() => {
            onSelectDate(thisDay);
          }}
        >
          {format(thisDay, "d")}
        </div>
      );

      current = addDays(current, 1);
    }

    return days;
  };

  const handlePrevMonth = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentMonth(subMonths(currentMonth, 1));
  };

  const handleNextMonth = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentMonth(addMonths(currentMonth, 1));
  };

  return (
    <div className="calendar-popup-wrapper">
      <div className="calendar">
        <div className="calendar-header">
          <div className="calendar-month-year">
            {format(currentMonth, "MMMM yyyy")}
          </div>
          <div className="calendar-navigation">
            <button
              type="button"
              className="calendar-nav-btn"
              onClick={handlePrevMonth}
              aria-label="Previous month"
            >
              <CustomIcon name="left" size={20} />
            </button>
            <button
              type="button"
              className="calendar-nav-btn"
              onClick={handleNextMonth}
              aria-label="Next month"
            >
              <CustomIcon name="right" size={20} />
            </button>
          </div>
        </div>
        
        <div className="calendar-weekdays">
          {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((day) => (
            <div key={day} className="calendar-weekday">
              {day}
            </div>
          ))}
        </div>
        
        <div className="calendar-grid">{renderDays()}</div>
      </div>
    </div>
  );
};

export default CalendarPopup;
